const rootDomain = 'cookieinformation.com';
const StorageService = {
  removeItem: (key) => {
    if (window.location.hostname.includes(rootDomain)) {
      document.cookie = `${key}=; path=/; domain=.cookieinformation.com; expires=Thu, 01 Jan 1970 00:00:01 GMT; secure`;
    } else {
      document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  },
  setItem: (key, value) => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 1);

    if (window.location.hostname.includes(rootDomain)) {
      document.cookie = `${key}=${value}; domain=.cookieinformation.com; expires=${date.toUTCString()}; path=/; SameSite=Lax; secure`;
    } else {
      document.cookie = `${key}=${value}; expires=${date.toUTCString()}`;
    }
  },
  getItem: key => {
    const cookie = document.cookie.match(`(?:(?:^|.*; *)${key} *= *([^;]*).*$)|^.*$`)[1];
    return cookie ? decodeURIComponent(cookie) : null;
  },
};
export default StorageService;
